import React from 'react';
import logo from '../assets/image/logo.svg';

const AppBar = props => {
  return (
    <div className="AppBar" >
      <img className="AppBarLogo" src={logo} alt="logo" />
      <div className="AppBarTitle" >
        料金シミュレーション
      </div>
    </div>
  );

}

export default AppBar;
